const feedbackTypes = {

  get: {
    request: "GET_FEEDBACK_REQUEST",
    success: "GET_FEEDBACK_SUCCESS",
    failure: "GET_FEEDBACK_FAILURE"
  },

  get_questions: {
    request: "GET_FEEDBACK_QUESTIONS_REQUEST",
    success: "GET_FEEDBACK_QUESTIONS_SUCCESS",
    failure: "GET_FEEDBACK_QUESTIONS_FAILURE"
  },

  index: {
    request: "FEEDBACK_INDEX_REQUEST",
    success: "FEEDBACK_INDEX_SUCCESS",
    failure: "FEEDBACK_INDEX_FAILURE"
  },

  mark_read: {
    request: "FEEDBACK_MARK_READ_REQUEST",
    success: "FEEDBACK_MARK_READ_SUCCESS",
    failure: "FEEDBACK_MARK_READ_FAILURE"
  },

  mark_unread: {
    request: "FEEDBACK_MARK_UNREAD_REQUEST",
    success: "FEEDBACK_MARK_UNREAD_SUCCESS",
    failure: "FEEDBACK_MARK_UNREAD_FAILURE"
  },

  mark_resolved: {
    request: "FEEDBACK_MARK_RESOLVED_REQUEST",
    success: "FEEDBACK_MARK_RESOLVED_SUCCESS",
    failure: "FEEDBACK_MARK_RESOLVED_FAILURE"
  },

}

export default feedbackTypes



// WEBPACK FOOTER //
// ./src/js/constants/feedbackTypes.js